import { ajaxLoadCart } from './loadCart';
import popupEvent from './popup';

export default function addToCart() {
  $('.js-add-to-cart').on('click', function () {
    const buyNow = $(this).data('buy-now');
    const id = $(this).data('product-id');
    const qty = $('input[name=quantity]').val() || 1;
    $('.js-add-to-cart').addClass('loading');

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      method: 'POST',
      dataType: 'json',
      data: {
        action: 'add_to_cart',
        id,
        qty
      },
      success: function (response) {
        $('.js-add-to-cart').removeClass('loading');
        $('.cart-count').text(response.count);
        if (buyNow) {
          jQuery.noConflict();
          $('#checkout').modal('show');
        } else {
          $('#checkout').after(response.popup);
          popupEvent();
        }
        ajaxLoadCart();
      }
    });
  })
}
